import * as amplitude from '@amplitude/analytics-browser';
import { autocapturePlugin } from '@amplitude/plugin-autocapture-browser';

// Default fallback to test API Key
export async function initAnalytics(config = { AMPLITUDE_API_KEY: '' }) {
  // Initialize Amplitude
  amplitude.init(config.AMPLITUDE_API_KEY, {
    defaultTracking: true,
  });

  amplitude.add(autocapturePlugin());
}

export function sendAnalyticsEvent(eventName: string, eventProperties: Record<string, unknown> = {}) {
  eventProperties['Page URL'] = window.location.href;
  amplitude.track(eventName, eventProperties);
}
